export const BLINK_ANIMATION_TIMEOUT = 300 // ms
export const BLINK_LEFT_VALUE = 45 // px
export const BESTSELLERS_ITEMS_LENGTH = 10;

export const GRAB_AGAIN_ITEMS_LENGTH = 6;